import { render } from "./menuWrapper.vue?vue&type=template&id=665ce92e&scoped=true"
import script from "./menuWrapper.vue?vue&type=script&lang=js"
export * from "./menuWrapper.vue?vue&type=script&lang=js"

import "./menuWrapper.vue?vue&type=style&index=0&id=665ce92e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665ce92e"],['__file',"menuWrapper.vue"]])

export default __exports__